import React, { useState, useEffect } from 'react'
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { NavLink } from "react-router-dom";
import EmailRestAPI from '../components/EmailRestAPI';
import { baseurladdress } from "../baseurl";
import axios from 'axios'
import moment from "moment";

const Swal = require('sweetalert2')
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1800,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

function Leaveapplyadd() {
    const accesstoken = localStorage.getItem("token");
    const accessstaffid = localStorage.getItem("staffid");
    const date = new Date();
    const futureDate = date.getDate();
    date.setDate(futureDate);
    const defaultValue = date.toLocaleDateString("en-CA");

    const [dateFrom, setDateFrom] = useState(defaultValue);
    const [dateTo, setDateTo] = useState('');
    const [totalLeaveDays, setTotalLeaveDays] = useState(0);
    const [data, setTableData] = useState([]);
    const [leaveBalanceRows, setLeaveBalanceRows] = useState([]);

    const [randomNumber, setRandomNumber] = useState(generateRandomNumber());
    const [leaveTypes, setLeaveTypes] = useState([]);
    const [selectedLeaveType, setSelectedLeaveType] = useState("");
    const [empCode, setEmpCode] = useState("");
    const [empName, setEmpName] = useState("");
    const [empDept, setEmpDept] = useState("");
    const [leaveModalVisible, setLeaveModalVisible] = useState(false);
    const [leaveModalData, setLeaveModalData] = useState([]);
    const [leaveModalTitle, setLeaveModalTitle] = useState("");
    const [leaveReason, setLeaveReason] = useState("");
    const [isHalfDay, setIsHalfDay] = useState(false);
    const [pendingModalVisible, setPendingModalVisible] = useState(false);
    const [pendingModalTitle, setPendingModalTitle] = useState("");
    const [pendingModalData, setPendingModalData] = useState([]);
    const [leaveHistory, setLeaveHistory] = useState([]);

    function generateRandomNumber() {
        return Math.floor(Math.random() * 100) + 1;
    }


    useEffect(() => {
        setRandomNumber(generateRandomNumber());
    }, []);

    const [showModal, setShowModal] = useState(false);
    const [isChecked, setIsChecked] = useState(false);

    const handleCheckboxChange = (e) => {
        setIsChecked(e.target.checked);
        setShowModal(e.target.checked);
    };

    const handleClose = () => {
        setShowModal(false);
        setIsChecked(false);
    };

    const selectedLeaveTypeItem = leaveTypes.find(
        (item) => String(item.leaveTypeId) === String(selectedLeaveType)
    );
    const selectedLeaveBalance = leaveBalanceRows.find(
        (item) => String(item.leaveType) === String(selectedLeaveTypeItem?.leaveTypeName)
    );
    const selectedAvailableLeaves = selectedLeaveBalance
        ? Math.max(
            toNumber(selectedLeaveBalance.availableLeaves) ||
                toNumber(selectedLeaveBalance.totalAllocated) -
                toNumber(selectedLeaveBalance.appliedLeaves) -
                toNumber(selectedLeaveBalance.pendingRequests),
            0
        )
        : toNumber(selectedLeaveTypeItem?.availableLeaves);

    useEffect(() => {
        if (isHalfDay) {
            setTotalLeaveDays(0.5);
            return;
        }

        if (dateFrom && dateTo) {
            const fromDate = new Date(dateFrom);
            const toDate = new Date(dateTo);
            const diffTime = Math.abs(toDate - fromDate);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1; // Including both start and end dates
            setTotalLeaveDays(diffDays);
        } else {
            setTotalLeaveDays(0);
        }
    }, [dateFrom, dateTo, isHalfDay]);

    useEffect(() => {
        if (isHalfDay) {
            setDateTo(dateFrom);
        }
    }, [isHalfDay, dateFrom]);

    const handleLeaveDetailClick = async (leaveTypeName, type) => {
        const staffid = localStorage.getItem("staffid");

        try {
            const response = await axios.get(
                `${baseurladdress}getusedleaves/${staffid}/${leaveTypeName}`,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`
                    }
                }
            );

            const leaveDetails = response.data.response || [];

            setLeaveModalTitle(`${type} Leave Details - ${leaveTypeName}`);
            setLeaveModalData(leaveDetails);
            setLeaveModalVisible(true);

        } catch (error) {
            console.error("Error fetching leave details:", error);
            setLeaveModalTitle(`${type} Leave Details - ${leaveTypeName}`);
            setLeaveModalData([]);
            setLeaveModalVisible(true);
        }
    };

    const handlePendingLeaveClick = async (leaveTypeName) => {
        const staffid = localStorage.getItem("staffid");

        try {
            const response = await axios.get(
                `${baseurladdress}getpendingleaves/${staffid}/${leaveTypeName}`,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`
                    }
                }
            );

            const pendingDetails = response.data.response || [];

            setPendingModalTitle(`Pending Leave Details - ${leaveTypeName}`);
            setPendingModalData(pendingDetails);
            setPendingModalVisible(true);

        } catch (error) {
            console.error("Error fetching pending leave details:", error);
            setPendingModalTitle(`Pending Leave Details - ${leaveTypeName}`);
            setPendingModalData([]);
            setPendingModalVisible(true);
        }
    };

    function toNumber(value) {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : 0;
    }

    function formatLeaveDays(value) {
        const num = toNumber(value);
        return Number.isInteger(num) ? String(num) : num.toFixed(1);
    }


    // useEffect(() => {
    //     const GetAllallocatedLeaves = () => {
    //         const staffid = localStorage.getItem("staffid");
    //         axios
    //             .get(`${baseurladdress}getallallocatedleave/${staffid}`, {
    //                 headers: {
    //                     Authorization: `Bearer ${accesstoken}`
    //                 }
    //             })
    //             .then(res => {
    //                 const datas = res.data.response;
    //                 const tdata = datas.map((item, index) => (
    //                     <tr key={index}>
    //                         <td>{index + 1}</td>
    //                         <td>{item.leaveassign_leavetypename}</td>
    //                         <td>{item.leaveassign_totalleave}</td>
    //                         <td
    //                             style={{ cursor: 'pointer', color: 'blue' }}
    //                             onClick={() => handleLeaveDetailClick(item.leaveassign_leavetypename, "Used")}
    //                         >
    //                             {item.leaveassign_appliedleaves}
    //                         </td>
    //                         <td>{item.leaveassign_totalleave - item.leaveassign_appliedleaves}</td>
    //                         <td style={{ textAlign: "left" }}>{item.leaveassign_pendingleaves}</td>
    //                     </tr>
    //                 ));
    //                 setTableData(tdata);
    //             })
    //             .catch(error => {
    //                 Toast.fire({
    //                     icon: 'error',
    //                     title: 'No leave data'
    //                 });
    //             });
    //     };

    //     GetAllallocatedLeaves();
    // }, []);
    const GetAllallocatedLeaves = () => {
    const staffid = localStorage.getItem("staffid");

    axios
        .get(`${baseurladdress}getallleaves/${staffid}`, {
            headers: {
                Authorization: `Bearer ${accesstoken}`
            }
        })
        .then(res => {
            const datas = res.data.response || [];
            setLeaveBalanceRows(datas);

            const tdata = datas.map((item, index) => {
                const totalAllocated = toNumber(item.totalAllocated);
                const appliedLeaves = toNumber(item.appliedLeaves);
                const pendingRequests = toNumber(item.pendingRequests);
                const usedLeaves = Math.max(totalAllocated - toNumber(item.availableLeaves) - pendingRequests, 0);
                const availableLeaves = Math.max(
                    toNumber(item.availableLeaves) ||
                        totalAllocated - appliedLeaves - pendingRequests,
                    0
                );
                const isPendingDisabled = pendingRequests === 0;
                return (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.leaveType}</td>
                        <td>{formatLeaveDays(totalAllocated)}</td>

                        <td
                            style={{ cursor: 'pointer', color: 'blue' }}
                            onClick={() =>
                                handleLeaveDetailClick(item.leaveType, "Used")
                            }
                        >
                            {formatLeaveDays(usedLeaves)}
                        </td>

                        <td>{formatLeaveDays(availableLeaves)}</td>

                        <td
                            style={{
                                cursor: isPendingDisabled
                                    ? 'not-allowed'
                                    : 'pointer',
                                color: isPendingDisabled
                                    ? 'gray'
                                    : 'blue',
                                textAlign: 'left'
                            }}
                            onClick={() => {
                                if (!isPendingDisabled) {
                                    handlePendingLeaveClick(item.leaveType);
                                }
                            }}
                        >
                            {formatLeaveDays(pendingRequests)}
                        </td>
                    </tr>
                );
            });

            setTableData(tdata);
        })
        .catch(error => {
            Toast.fire({
                icon: 'error',
                title: 'No leave data'
            });
        });
};

useEffect(() => {
    GetAllallocatedLeaves();
}, []);


    const getLeaveTypes = async () => {
        try {
            const staffid = localStorage.getItem("staffid");

            const res = await axios.get(
                `${baseurladdress}getallallocatedleavetype/${staffid}`,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`,
                    },
                }
            );

            setLeaveTypes(Array.isArray(res.data?.response) ? res.data.response : []);
        } catch (error) {
            console.error(error);
            Toast.fire({
                icon: 'error',
                title: 'Error fetching leave types'
            });
        }
    };

    useEffect(() => {
        getLeaveTypes();
    }, []);

    useEffect(() => {
        const staffid = localStorage.getItem("staffid");
        axios
            .get(`${baseurladdress}getemployeedetailss/${staffid}`, {
                headers: {
                    Authorization: `Bearer ${accesstoken}`
                }
            })
            .then((res) => {
                const emp = res.data.response;
                setEmpCode(emp.staff_code);
                setEmpName(emp.staff_name);
                setEmpDept(emp.dept_name || emp.department_name || emp.staff_department_name || "");
            })
            .catch((err) => {
                console.error("Failed to load employee code", err);
            });
    }, []);


    const checkDateOverlap = async (fromDate, toDate, halfDay) => {
        const staffid = localStorage.getItem("staffid");
        
        try {
            // Fetch both pending and approved/recommended leaves
            const [pendingRes, historyRes] = await Promise.all([
                axios.get(`${baseurladdress}getpendingleaves/${staffid}/all`, {
                    headers: { Authorization: `Bearer ${accesstoken}` }
                }),
                axios.get(`${baseurladdress}getleavehistory/${staffid}`, {
                    headers: { Authorization: `Bearer ${accesstoken}` }
                })
            ]);

            const pendingLeaves = Array.isArray(pendingRes.data?.response) ? pendingRes.data.response : [];
            const historyLeaves = Array.isArray(historyRes.data?.response) ? historyRes.data.response : [];
            
            // Combine pending and approved/recommended leaves (exclude cancelled)
            const allLeaves = [...pendingLeaves, ...historyLeaves].filter(
                leave => leave.ddchrleave_status !== 3 // Exclude cancelled
            );

            const newFromDate = new Date(fromDate);
            const newToDate = halfDay ? new Date(fromDate) : new Date(toDate);

            // Check for overlapping leaves
            const overlappingLeave = allLeaves.find((leave) => {
                const existingFrom = new Date(leave.ddchrleave_appliedfordate);
                const existingTo = new Date(leave.ddchrleave_appliedtodate);
                
                // Check if dates overlap
                // Overlap occurs if: (newStart <= existingEnd) AND (newEnd >= existingStart)
                return (
                    (newFromDate <= existingTo && newToDate >= existingFrom)
                );
            });

            if (overlappingLeave) {
                const existingFrom = moment(overlappingLeave.ddchrleave_appliedfordate).format("DD-MM-YYYY");
                const existingTo = moment(overlappingLeave.ddchrleave_appliedtodate).format("DD-MM-YYYY");
                const statusText = overlappingLeave.ddchrleave_status === 1 ? "Pending" :
                                  overlappingLeave.ddchrleave_status === 2 ? "Approved" :
                                  overlappingLeave.ddchrleave_status === 4 ? "Recommended" : "Unknown";
                
                return {
                    hasOverlap: true,
                    message: `You already have a ${statusText} leave from ${existingFrom} to ${existingTo}. Cannot apply for overlapping dates.`
                };
            }

            return { hasOverlap: false };
        } catch (error) {
            console.error("Error checking date overlap:", error);
            // If check fails, allow submission (fail-safe approach)
            return { hasOverlap: false };
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!selectedLeaveType) {
            Swal.fire("Warning", "Please select a leave type.", "warning");
            return;
        }

        if (!dateFrom) {
            Swal.fire("Warning", "Please select From Date.", "warning");
            return;
        }

        if (!isHalfDay && !dateTo) {
            Swal.fire("Warning", "Please select To Date.", "warning");
            return;
        }

        if (!isHalfDay && new Date(dateTo) < new Date(dateFrom)) {
            Swal.fire("Warning", "To Date cannot be earlier than From Date.", "warning");
            return;
        }

        if (!leaveReason.trim()) {
            Swal.fire("Warning", "Please enter reason for leave.", "warning");
            return;
        }

        // Check for date overlap before proceeding
        const overlapCheck = await checkDateOverlap(dateFrom, dateTo, isHalfDay);
        if (overlapCheck.hasOverlap) {
            Toast.fire({
                icon: 'warning',
                title: overlapCheck.message
            });
            return;
        }

        const leaveTypeName = selectedLeaveTypeItem?.leaveTypeName || "";
        const requestedDays = toNumber(totalLeaveDays);

        if (requestedDays <= 0) {
            Swal.fire("Warning", "Please select valid leave dates.", "warning");
            return;
        }

        if (selectedAvailableLeaves <= 0) {
            Swal.fire(
                "Warning",
                `No available balance left for ${leaveTypeName || "this leave type"}. You cannot apply for this leave type.`,
                "warning"
            );
            return;
        }

        if (requestedDays > selectedAvailableLeaves) {
            Swal.fire(
                "Warning",
                `You can apply only ${selectedAvailableLeaves} leave day(s) for ${leaveTypeName || "this leave type"}.`,
                "warning"
            );
            return;
        }

        const data = {
            ddchrleave_staffid: accessstaffid,
            ddchrleave_typeid: selectedLeaveType,
            ddchrleave_typename: leaveTypeName,
            ddchrleave_staffname: empName,
            ddchrleave_staffdept: empDept,
            ddchrleave_staffcode: empCode,
            ddchrleave_appliedfordate: dateFrom,
            ddchrleave_appliedtodate: isHalfDay ? dateFrom : dateTo,
            ddchrleave_leaveapproverid: "",
            ddchrleave_leaveapprovername: "",
            ddchrleave_reason: leaveReason.trim(),
            ddchrleave_halfday: isHalfDay ? 1 : 0,
            staffid: accessstaffid,
        };

        try {
            const res = await fetch(
                baseurladdress + `addleaverequest`,
                {
                    method: "POST",
                    body: JSON.stringify(data),
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${accesstoken}`,
                    },
                }
            );

            const result = await res.json();

            if (result.status === "success") {
                Toast.fire({
                    icon: 'success',
                    title: 'Request added successfully'
                });

                GetAllallocatedLeaves();
                getLeaveTypes();
                fetchLeaveHistory();

                setSelectedLeaveType("");
                setDateTo("");
                setLeaveReason("");
                setIsHalfDay(false);
            } else {
                Swal.fire(
                    "Error",
                    result.message || "Failed to submit leave request.",
                    "error"
                );
            }
        } catch (error) {
            console.error("Error submitting leave request:", error);
            Swal.fire("Error", "Something went wrong while submitting.", "error");
        }
    };

    const fetchLeaveHistory = () => {
        const staffid = localStorage.getItem("staffid");
        const accesstoken = localStorage.getItem("token");

        axios
            .get(`${baseurladdress}getleavehistory/${staffid}`, {
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                },
            })
            .then((res) => {
               const data = Array.isArray(res.data?.response)
    ? res.data.response
    : [];

const rows = data.map((item, index) => {
                    let statusText = "Unknown";

                    if (item.ddchrleave_status === 1) {
                        statusText = "Pending";
                    } else if (item.ddchrleave_status === 2) {
                        statusText = "Approved";
                    } else if (item.ddchrleave_status === 3) {
                        statusText = "Cancelled";
                    } else if (item.ddchrleave_status === 4) {
                        statusText = "Recommented";
                    }

                    return (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.ddchrleave_typename}</td>
                            <td>{moment(item.ddchrleave_appliedfordate).format("DD-MM-YYYY")}</td>
                            <td>{moment(item.ddchrleave_appliedtodate).format("DD-MM-YYYY")}</td>
                            <td style={{ textAlign: "left" }}>{statusText}</td>
                        </tr>
                    );
                });

                setLeaveHistory(rows);
            })
            .catch((err) => {
                console.error("Error fetching leave history:", err);
                setLeaveHistory([
                    <tr key="no-data">
                        <td colSpan="5" className="text-center">No leave history found</td>
                    </tr>,
                ]);
            });
    };


    return (
        <div>
            <Topnavbar />
            <Sidennav />
            <div className="content-wrap">
                <div className="container-fluid">
                    {/* <NavLink activeClassName="active-link" to={"/leaveapply"}>
                        <div style={{ display: "flex" }}>
                            <a className="float">
                                <i className="fa fa-arrow-left my-float" style={{ "marginTop": "21px" }}></i>
                            </a>
                        </div>
                    </NavLink> */}

                    <form onSubmit={handleSubmit}>
                        <div className='row'>
                            <div className="col-xl-12 col-xxl-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h4 className="card-title">New Leave Application</h4>
                                    </div>
                                    <div className="card-body">


                                        <div className="col-xl-12 col-xxl-12">
                                            {/* <div className="card"> */}
                                            {/* <div className="card-header">
                                                    <h4 className="card-title">New Leave Application</h4>
                                                </div> */}
                                            <div className="card-body">



                                                <div class="card">
                                                    <div class="card-header">
                                                        <ul class="nav nav-tabs card-header-tabs" id="leaveTabs" role="tablist">
                                                            <li class="nav-item">
                                                                <a
                                                                    class="nav-link active"
                                                                    id="allocated-tab"
                                                                    data-toggle="tab"
                                                                    href="#allocated"
                                                                    role="tab"
                                                                    aria-controls="allocated"
                                                                    aria-selected="true"
                                                                >
                                                                    Allocated Leaves
                                                                </a>
                                                            </li>
                                                            <li class="nav-item">
                                                                <a
                                                                    class="nav-link"
                                                                    id="history-tab"
                                                                    data-toggle="tab"
                                                                    href="#history"
                                                                    role="tab"
                                                                    aria-controls="history"
                                                                    aria-selected="false"
                                                                    onClick={fetchLeaveHistory}
                                                                >
                                                                    Leave History
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                    <div class="card-body tab-content" id="leaveTabsContent">
                                                        {/* Allocated Leaves Tab */}
                                                        <div
                                                            class="tab-pane fade show active"
                                                            id="allocated"
                                                            role="tabpanel"
                                                            aria-labelledby="allocated-tab"
                                                        >
                                                            <table class="table table-bordered">
                                                                <thead style={{ textAlign: "left" }}>
                                                                    <tr>
                                                                        <th>Sl No</th>
                                                                        <th>Leave Type</th>
                                                                        <th>Total Allocated Leaves</th>
                                                                        <th>Applied/Used Leaves</th>
                                                                        <th>Available Leaves</th>
                                                                        <th style={{ textAlign: "left" }}>Request Status</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>{data}</tbody>
                                                            </table>
                                                        </div>

                                                        {/* Leave History Tab */}
                                                        <div
                                                            class="tab-pane fade"
                                                            id="history"
                                                            role="tabpanel"
                                                            aria-labelledby="history-tab"
                                                        >
                                                            <table class="table table-bordered">
                                                                <thead style={{ textAlign: "center" }}>
                                                                    <tr>
                                                                        <th>Sl No</th>
                                                                        <th>Leave Type</th>
                                                                        <th>From Date</th>
                                                                        <th >To Date</th>
                                                                        <th style={{ textAlign: "center" }}>Status</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
    {Array.isArray(leaveHistory) && leaveHistory.length > 0 ? (
        leaveHistory
    ) : (
        <tr>
            <td colSpan="5" className="text-center">
                No leave history found
            </td>
        </tr>
    )}
</tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="card mt-4">
                                                    <div class="card-header">
                                                        <h5 class="card-title mb-0">Add Leave</h5>
                                                    </div>
                                                    <div class="card-body">
                                                        <div className="form-row">


                                                            <div className="col-sm-2 mt-2 mt-sm-0">
                                                                <h6>Series</h6>
                                                                <input type="text" className='form-control' value={randomNumber} ></input>
                                                            </div>

                                                        <div className="col-sm-3 mt-2 mt-sm-0">
    <h6>Leave Type</h6>

    <select
        className="form-control select"
        name="leave_type"
        value={selectedLeaveType}
        onChange={(e) => setSelectedLeaveType(e.target.value)}
    >
        <option value="" disabled>
            Select leave type
        </option>

        {leaveTypes.map((item, index) => (
            <option key={index} value={item.leaveTypeId}>
                {item.leaveTypeName} ({formatLeaveDays(item.availableLeaves)} left)
            </option>
        ))}
    </select>
</div>
                                                            <div className="col-sm-3 mt-3 mt-sm-0">
                                                                <h6>Employee Code</h6>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={empCode}
                                                                    readOnly
                                                                />
                                                            </div>

                                                            <div className="col-sm-2 mt-3 mt-sm-0">
                                                                <h6>Employee Name</h6>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={empName}
                                                                    readOnly
                                                                />
                                                            </div>
                                                            <div className="col-sm-2 mt-3 mt-sm-0">
                                                                <h6>Department</h6>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    value={empDept}
                                                                    readOnly
                                                                />
                                                            </div>


                                                            <div class="col-sm-6">

                                                                <div class="form-group col-12">
                                                                    <label for="dateFrom">From Date</label>
                                                                    <input
                                                                        type="date"
                                                                        id="dateFrom"
                                                                        class="form-control"
                                                                        value={dateFrom}
                                                                        onChange={(e) => setDateFrom(e.target.value)}
                                                                        min={new Date().toISOString().split("T")[0]}
                                                                        required
                                                                    />
                                                                </div>
                                                                <div class="form-group col-12 mt-3">
                                                                    <label for="dateTo">To Date</label>
                                                                    <input
                                                                        type="date"
                                                                        id="dateTo"
                                                                        value={dateTo}
                                                                        onChange={(e) => setDateTo(e.target.value)}
                                                                        min={dateFrom}
                                                                        class="form-control"
                                                                        disabled={isHalfDay}
                                                                        required={!isHalfDay}
                                                                    />
                                                                </div>


                                                                <div class="form-group col-12 mt-3 ">

                                                                    <input
                                                                        type="checkbox"
                                                                        style={{ marginRight: '8px' }}
                                                                        checked={isHalfDay}
                                                                        onChange={(e) => setIsHalfDay(e.target.checked)}
                                                                    />
                                                                    <span>Half Day</span>
                                                                </div>
                                                                <div class="form-group col-12 mt-3 ">
                                                                    <h6> Total Leave Days </h6>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={totalLeaveDays}
                                                                        readOnly

                                                                    />

                                                                </div>

                                                            </div>



                                                            <div class="col-sm-6">

                                                                <div class="form-group col-12">
                                                                    <h6>Reason for Leave</h6>
                                                                    <textarea
                                                                        className="form-control text textaddstaff"
                                                                        name="ddchrleave_reason"
                                                                        value={leaveReason}
                                                                        onChange={(e) => setLeaveReason(e.target.value)}
                                                                        required
                                                                    />

                                                                </div>

                                                            </div>

                                                            {/* <div
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    marginTop: '1rem',
                                                                    marginBottom: '1rem',

                                                                }} >

                                                                <input
                                                                    type="checkbox"
                                                                    style={{ marginRight: '8px', marginLeft: '27px' }}
                                                                    onChange={handleCheckboxChange}
                                                                    checked={isChecked}

                                                                />
                                                                <span>Follow via email</span>

                                                            </div> */}

                                                        </div>

                                                        {/* {showModal && <EmailRestAPI showModal={showModal} handleClose={handleClose} />} */}


                                                        <div className="col-12 d-flex justify-content-center mt-4">
                                                            <button type="submit" className="btn btn-primary">
                                                                Submit
                                                            </button>
                                                        </div>

                                                    </div>
                                                </div>
                                                {/* </div> */}
                                            </div>
                                            {/* </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {leaveModalVisible && (
                            <div className="modal d-block" tabIndex="-1" role="dialog" style={{ background: 'rgba(0,0,0,0.5)' }}>
                                <div className="modal-dialog" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">{leaveModalTitle}</h5>
                                            <button type="button" className="close" onClick={() => setLeaveModalVisible(false)}>
                                                <span>&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th style={{ textAlign: "left" }}>From Date</th>
                                                        <th style={{ textAlign: "left" }}>To Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Array.isArray(leaveModalData) &&
leaveModalData.map((item, index) => {
                                                        const fromDate = moment(item.ddchrleave_appliedfordate).format("DD-MM-YYYY");
                                                        const toDate = moment(item.ddchrleave_appliedtodate).format("DD-MM-YYYY");

                                                        return (
                                                            <tr key={index}>
                                                                <td>{fromDate}</td>
                                                                <td style={{ textAlign: "left" }}>{toDate}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {pendingModalVisible && (
                            <div className="modal d-block" tabIndex="-1" role="dialog" style={{ background: 'rgba(0,0,0,0.5)' }}>
                                <div className="modal-dialog" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h5 className="modal-title">{pendingModalTitle}</h5>
                                            <button type="button" className="close" onClick={() => setPendingModalVisible(false)}>
                                                <span>&times;</span>
                                            </button>
                                        </div>
                                        <div className="modal-body">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th style={{ textAlign: "left" }}>From Date</th>
                                                        <th style={{ textAlign: "left" }}>To Date</th>
                                                        <th style={{ textAlign: "left" }}>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                   {Array.isArray(pendingModalData) &&
pendingModalData.map((item, index) => {
                                                        const fromDate = moment(item.ddchrleave_appliedfordate).format("DD-MM-YYYY");
                                                        const toDate = moment(item.ddchrleave_appliedtodate).format("DD-MM-YYYY");

                                                        let badgeClass = "";
                                                        let statusText = "";

                                                        if (item.ddchrleave_status === 1) {
                                                            badgeClass = "bg-warning";
                                                            statusText = "Pending";
                                                        } else if (item.ddchrleave_status === 2) {
                                                            badgeClass = "bg-success";
                                                            statusText = "Approved";
                                                        } else if (item.ddchrleave_status === 3) {
                                                            badgeClass = "bg-danger";
                                                            statusText = "Cancelled";
                                                        } else if (item.ddchrleave_status === 4) {
                                                            badgeClass = "bg-info";
                                                            statusText = "Recommented";
                                                        }

                                                        return (
                                                            <tr key={index}>
                                                                <td>{fromDate}</td>
                                                                <td>{toDate}</td>
                                                                <td style={{ textAlign: "left" }}>
                                                                    <span className={`badge ${badgeClass}`}>
                                                                        {statusText}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}


                    </form>
                </div>
            </div>
        </div>
    )
}

export default Leaveapplyadd
